@if (item().url && !item().external) {
  <li [ngClass]="item().classes!" [routerLinkActive]="['active']">
    <a class="nav-link" [target]="item().target ? '_blank' : '_self'" [routerLink]="[item().url]" (click)="closeOtherMenu($event)">
      @if (item().icon) {
        <span class="coded-micon"><i [ngClass]="item().icon"></i></span>
      }
      @if (item().icon) {
        <span class="coded-mtext">{{ item().title }}</span>
      } @else {
        {{ item().title }}
      }
    </a>
  </li>
}
@if (item().url && item().external) {
  <li [ngClass]="item().classes!" [routerLinkActive]="['active']">
    <a [target]="item().target ? '_blank' : '_self'" [href]="item().url">
      @if (item().icon) {
        <span class="coded-micon"><i [ngClass]="item().icon"></i></span>
      }
      @if (item().icon) {
        <span class="coded-mtext">{{ item().title }}</span>
      } @else {
        {{ item().title }}
      }
    </a>
  </li>
}
